import * as React from "react"
const ArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    data-name="Group 95819"
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill="#031629" data-name="Ellipse 40415" />
    <path
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.5}
      d="M9.499 6.938a.428.428 0 0 0 .132.3l5.268 5.262-5.268 5.265a.428.428 0 1 0 .605.605l5.563-5.57a.428.428 0 0 0 0-.605l-5.563-5.563a.428.428 0 0 0-.737.306Z"
      data-name="icons8-expand-arrow (2)"
    />
    <path
      fill="#fff"
      stroke="#fff"
      strokeWidth={0.5}
      d="M9.498 6.938a.428.428 0 0 0 .132.3l5.268 5.262-5.268 5.265a.428.428 0 1 0 .605.605l5.563-5.57a.428.428 0 0 0 0-.605l-5.563-5.563a.428.428 0 0 0-.737.306Z"
      data-name="icons8-expand-arrow (2)"
    />
  </svg>
)
export default ArrowRight
